module.exports = __webpack_public_path__ + "img/ics_o_star.cdef1a6f.svg";